import { UserConfigContext } from "contexts/UserConfigContext";
import { useContext } from "react";

/**
 * Returns the user config based on current context.
 * - Inside a dataset: returns dataset-specific feature config
 * - Outside a dataset: returns global user config
 */
export function useUserConfig() {
  const context = useContext(UserConfigContext);
  if (context === undefined) {
    throw new Error(
      "useUserConfigContext must be used within a UserConfigProvider",
    );
  }
  return context;
}
